import React from 'react';
import dynamic from 'next/dynamic';
const Image = dynamic(() => import('../Image/Image'))
import PropTypes from 'prop-types';

export default function CloudinaryImage({document}) {
    const classNames = document?.fields?.className;

    return (<div className={classNames}>
        <Image image={document}/>
    </div>);
}

CloudinaryImage.propTypes = {
    document: PropTypes.object,
};